import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./TermsSection.css";

import bgImage from "../../assets/Institute/DSC_0110.JPG";
import overlay1 from "../../assets/cta.avif";
import overlay2 from "../../assets/cta.avif";
import overlay3 from "../../assets/cta.avif";

const PioneersSection1 = () => {
  const [count, setCount] = useState({ teachers: 0, schools: 0, years: 0 });

  useEffect(() => {
    let start = 0;
    const interval = setInterval(() => {
      start++;
      if (start <= 5500)
        setCount({
          teachers: start,
          schools: Math.floor(start / 20),
          years: Math.floor(start / 275),
        });
      else clearInterval(interval);
    }, 1);
    return () => clearInterval(interval);
  }, []);

  return (
    <section
      className="pioneers-revamp-1"
      id="pioneers-1"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="overlay-1"></div>

      <div className="pioneers-content-1">
        <motion.div
          className="pioneers-text-1"
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
        <h2>Welcome to NIECCE Edu Solutions Pvt Ltd.</h2>
        <p>We are committed to customer satisfaction. This Refund Policy explains how we handle requests for refunds for our teacher training programs, consulting services, and publications like the Lil-Beez series and other book titles.</p>
        <h3>1. Teacher Training Programs</h3>
        <ul className="pr-features-list">
        <li>Once paid for the program, it cannot be refunded. transferred or adjusted. </li>
        <li>Refund is possible only when NIECCE Edu Solutions Pvt Ltd decides to not conduct the program that is planned to start.</li>
        <li>In case of extenuating circumstances, we may consider partial refunds on a case-by-case basis.</li>
        </ul>
        <h3>2. Consulting Services</h3>
        <ul className="pr-features-list">
        <li>Refunds for consulting services are not typically provided. However, if you are dissatisfied with the service received, please contact us within 10 days of the service delivery to discuss potential remedies or partial refunds.</li>
        <li>Any refunds granted will be at the discretion of NIECCE Edu Solutions Pvt Ltd.</li>
        </ul>   
        <h3>3. Publications (Including Lil-Beez Series and Other Titles)</h3>
        <ul className="pr-features-list">
        <li>Refunds for books and publications are available only in cases of defects or damage upon delivery.</li>
        <li>Requests for refunds must be made within 3 days of receiving the product.</li>
        <li>To qualify for a refund, the product must be returned in its original condition.</li>
        <li>Return of Books after more than 1 month of delivery, refunds will not be provided.</li>
        </ul>
        <h3>4. Process for Requesting a Refund</h3>
        <ul className="pr-features-list">
        <li>To request a refund, please contact us at info@niecce.com with your order number, details of the product or service, and the reason for the refund request.</li>
        <li>We will review your request and notify you of the approval or rejection of your refund.</li>
        </ul>
        <h3>5. Approved Refunds</h3>
        <p>Once your refund is approved, it will be processed, and a credit will automatically be applied to your original method of payment within a certain number of days. Please note that it may take some time for your bank or credit card company to process and post the refund.</p>
        <h3>6. Late or Missing Refunds</h3>
        <p>If you haven’t received a refund yet, first check your bank account again. Then contact your credit card company, it may take some time before your refund is officially posted. Next, contact your bank. There is often some processing time before a refund is posted.</p>
        <h3>7. Contact Us</h3>
        <p>If you have any questions about our Refund Policy, please contact us at <b>info@niecce.com</b></p>
        </motion.div>        
      </div>
    </section>
  );
};

export default PioneersSection1;
